import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
} from "@angular/core";
import { ActivatedRoute } from "@angular/router";

import { DashboardService } from "../../../services/dashboard.service";
import { CalaReportComponent } from "../cala-report/cala-report.component";

@Component({
  selector: "app-collector-report",
  templateUrl: "./collector-reports.component.html",
  styleUrls: [
    "../dashboard-report/dashboard-report.component.css",
    "./collector-reports.component.css",
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CollectorReportComponent extends CalaReportComponent {
  reportKind = "Collector";

  constructor(
    route: ActivatedRoute,
    dashboardService: DashboardService,
    cdr: ChangeDetectorRef
  ) {
    super(route, dashboardService, cdr);
  }

  get collectorId(): string {
    return this.calaId;
  }

  get collectorName(): string {
    return this.calaName;
  }

  get calas(): any[] {
    return this.projects;
  }

  get calaPages(): any[][] {
    return this.projectPages;
  }

  protected loadDashboardData(id: string) {
    return this.dashboardService.getCollectorDashboardData(id);
  }
}
